import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, Button, Snackbar } from "@mui/material";
import Settings from "../assets/images/Settings.svg";
import Scale from "../assets/images/Scale.svg";
import Calling from "../assets/images/Calling.svg";
import contactus from "../assets/images/contactus.png";
import { useAuth } from "../auth/AuthContext";
import GradientLayout from "./GradientLayout";
import { useApi } from "../api/useApi";
import { motion, AnimatePresence } from "framer-motion";
import ContactUsPopup from "../components/ContactusPage";
const domains = ["DevOps", "SRE"];

function getUserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getGreeting(timeZone) {
  const now = new Date();
  const userTimeStr = now.toLocaleString("en-US", {
    timeZone,
    hour12: false,
    hour: "2-digit",
  });
  const userHour = parseInt(userTimeStr, 10);

  if (userHour >= 5 && userHour < 12) return "Good Morning!";
  if (userHour >= 12 && userHour < 17) return "Good Afternoon!";
  return "Good Night!";
}

export default function FinalCard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { request } = useApi();

  const [currentDomain, setCurrentDomain] = useState("SRE");
  const otherDomain = domains.find((d) => d !== currentDomain);
  const assessmentStartLink = `/questions/${otherDomain.toLowerCase()}`;
  const [snackOpen, setSnackOpen] = useState(false);
  const [notifMessage, setNotifMessage] = useState("");
  const [contactButtonDisable, setContactButtonDisable] = useState(false);

  const params = new URLSearchParams(location.search);
  const completedDomain = params.get("domain");
  const userMail = params.get("email");
  const evaluationId = params.get("evaluationId");
  const othersDomainEvaluationId =
    otherDomain == "SRE"
      ? localStorage.getItem("lastCompletedSREId")
      : localStorage.getItem("lastCompletedDevOpsId");
  const userName = params.get("name");
  const [timeZone, setTimeZone] = useState("UTC");
  const [greeting, setGreeting] = useState("Hello!");
  const sendingRef = useRef(false);
  const [userData, setUserData] = useState();
  const [Opencontactus, setOpencontactus] = useState(false);
  const SuccessBanner = ({ open, message }) => {
    return (
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            style={{
              position: "fixed",
              bottom: "2rem",
              left: "35%",
              transform: "translateX(-50%)",
              display: "inline-flex",
              alignItems: "center",
              gap: "1rem",
              borderRadius: "1rem",
              border: "1px solid #00A300",
              background: "#016100",
              color: "#FFFFFF",
              // fontFamily: "Akkurat-Bold, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 400,
              padding: "0.75rem 1.25rem",
              zIndex: 2000,
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
              textAlign: "center",
              maxWidth: "90%",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
                fill="#24A148"
              />
            </svg>

            <span>{message}</span>
          </motion.div>
        )}
      </AnimatePresence>
    );
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const domainParam = params.get("domain");
    if (domainParam) {
      const normalizedDomain = domains.find(
        (d) => d.toLowerCase() === domainParam.toLowerCase(),
      );
      setCurrentDomain(normalizedDomain || "SRE");
    } else {
      setCurrentDomain("SRE");
    }
  }, [location.search]);

  useEffect(() => {
    const tz = getUserTimeZone();
    setTimeZone(tz);
    setGreeting(getGreeting(tz));
  }, []);

  const getDomainIcon = (domain) => {
    if (!domain) return null;

    return domain.toLowerCase() === "devops" ? Scale : Settings;
  };

  const getDomainIconStyle = (domain) => {
    if (!domain) return {};

    return domain.toLowerCase() === "devops"
      ? { width: "32.003px", height: "31.999px" }
      : { width: "30.47px", height: "32px" };
  };
  const handleContactUs = async () => {
    if (sendingRef.current) return;
    sendingRef.current = true;
    try {
      const requests = await request({
        url: "/user/by-email",
        method: "GET",
        params: { email: user.email },
      });

      if (requests[0]?.emailId) {
        setUserData(requests[0]);
        setOpencontactus(true);
      }
    } catch (err) {
      console.error(err);
      setNotifMessage("Unable to process request. Try again.");
    }
    setTimeout(() => {
      sendingRef.current = false; // unlock after 400ms
    }, 400);
  };
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        // gap: 1,
        mt: "0px",
      }}
    >
      {/* 🔵 ROW 1 → TWO CARDS SIDE-BY-SIDE */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2,
          padding: "16px 16px",
        }}
      >
        {/* ---------------- LEFT CARD (Completed Domain) ---------------- */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.8rem",
            padding: "1.25rem",
            borderRadius: "1rem",
            border: "1px solid #C0C7CF",
            backgroundColor: "#FFF",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          {/* DOMAIN ICON */}
          <Box
            component="img"
            src={getDomainIcon(completedDomain)}
            alt={`${completedDomain} icon`}
            sx={getDomainIconStyle(completedDomain)}
          />

          <Typography
            sx={{
              fontFamily: "Akkurat-Bold",
              fontSize: { xs: "1.1rem", md: "24px" },
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            {completedDomain.toUpperCase()} Assessment
          </Typography>

          <Typography
            sx={{
              fontFamily: "Akkurat",
              fontSize: { xs: "1rem", md: "20px" },
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            {completedDomain.toUpperCase()} assessment completed successfully
          </Typography>

          <Typography
            sx={{ fontSize: "14px", color: "#3C4044", fontFamily: "Akkurat" }}
          >
            Your assessment has been successfully completed and the report can
            be generated.
          </Typography>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
            <Button
              onClick={() =>
                navigate(`/history-page?domain=${completedDomain}`)
              }
              sx={{
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                background: "#0036DD",
                color: "#FFF",
                padding: "0.5rem 1rem",
                borderRadius: "2rem",
                textTransform: "none",
                fontFamily: "Akkurat",
                fontSize: "14px",
                lineHeight: "10px",
              }}
            >
              View Dashboard
            </Button>
            <Button
              onClick={() =>
                navigate(
                  `/sre-score?evaluationId=${evaluationId}&domain=${encodeURIComponent(
                    completedDomain,
                  )}&email=${encodeURIComponent(userMail)}&name=${encodeURIComponent(
                    userName,
                  )}`,
                )
              }
              sx={{
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                background: "#0036DD",
                color: "#FFF",
                padding: "0.5rem 1rem",
                borderRadius: "2rem",
                textTransform: "none",
                fontFamily: "Akkurat",
                fontSize: "14px",
                lineHeight: "10px",
              }}
            >
              View Report
            </Button>
            <Button
              onClick={() => navigate(`/questions/${completedDomain}`)}
              sx={{
                border: "1px solid #1F2D5C",
                color: "#1F2D5C",
                padding: "0.5rem 1rem",
                borderRadius: "2rem",
                textTransform: "none",
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                fontFamily: "Akkurat",
                fontSize: "14px",
                lineHeight: "10px",
              }}
            >
              Retake Assessment
            </Button>
          </Box>
        </Box>

        {/* ---------------- RIGHT CARD (Other Domain) ---------------- */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.8rem",
            padding: "1.25rem",
            borderRadius: "1rem",
            border: "1px solid #C0C7CF",
            backgroundColor: "#FFF",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          {/* DOMAIN ICON */}
          <Box
            component="img"
            src={getDomainIcon(otherDomain)}
            alt={`${otherDomain} icon`}
            sx={getDomainIconStyle(otherDomain)}
          />

          <Typography
            sx={{
              fontFamily: "Akkurat-Bold",
              fontSize: { xs: "1.1rem", md: "24px" },
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            {otherDomain} Assessment
          </Typography>

          <Typography
            sx={{
              fontFamily: "Akkurat",
              fontSize: { xs: "1rem", md: "20px" },
              fontWeight: 400,
              color: "#3C4044",
            }}
          >
            Start {otherDomain} assessment.
          </Typography>

          <Typography
            sx={{ fontSize: "14px", color: "#3C4044", fontFamily: "Akkurat" }}
          >
            Your assessment has been successfully completed and the report can
            be generated
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
            <Button
              onClick={() => navigate(`/questions/${otherDomain}`)}
              sx={{
                background: "#0036DD",
                color: "#FFF",
                padding: "0.5rem 1rem",
                borderRadius: "2rem",
                textTransform: "none",
                width: { xs: "100%", sm: "180px" },
                height: "32px",
                fontSize: "14px",
                fontFamily: "Akkurat",
              }}
            >
              Start Assessment
            </Button>
            {othersDomainEvaluationId == undefined ? (
              <></>
            ) : (
              <Button
                onClick={() =>
                  navigate(
                    `/sre-score?evaluationId=${othersDomainEvaluationId}&domain=${encodeURIComponent(
                      otherDomain,
                    )}&email=${encodeURIComponent(userMail)}&name=${encodeURIComponent(
                      userName,
                    )}`,
                  )
                }
                sx={{
                  width: { xs: "100%", sm: "180px" },
                  height: "32px",
                  background: "#0036DD",
                  color: "#FFF",
                  padding: "0.5rem 1rem",
                  borderRadius: "2rem",
                  textTransform: "none",
                  fontFamily: "Akkurat",
                  fontSize: "14px",
                  lineHeight: "10px",
                }}
              >
                View Report
              </Button>
            )}
          </Box>
        </Box>
      </Box>

      {/* 🔵 ROW 2 → FULL-WIDTH CONTACT US CARD */}
      <Box sx={{ height: "1px" }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "0.5rem",
          alignSelf: "stretch",
          padding: "20px 16px",
          borderRadius: "1rem",
          border: "1px solid #C0C7CF",
          backgroundColor: "#FFF",
          margin: "0px 16px",

          boxSizing: "border-box",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        {/* Contact Us Icon */}
        <Box
          component="img"
          src={Calling}
          alt="Contact Icon"
          sx={{
            width: "31.946px",
            height: "32px",
          }}
        />

        <Typography
          sx={{
            color: "#3C4044",
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Akkurat",
            fontSize: "1.125rem",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
          }}
        >
          Have a question? We’re here to help!
        </Typography>

        <Typography
          sx={{
            color: "#3C4044",
            fontFeatureSettings: "'liga' off, 'clig' off", // ✅ same as CSS
            fontFamily: "Akkurat",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            alignSelf: "stretch", // ✅ same property applied
          }}
        >
          If you have any queries or need further support, head over to our
          Contact form and share your details. Our team will get back to you
          promptly with the assistance you need — don't hesitate, reach out
          today!
        </Typography>

        <Button
          onClick={async () => {
            handleContactUs();
            //   setContactButtonDisable(true)
            //   try {
            //     await request({
            //       url: "/contact/trigger-email",
            //       method: "POST",
            //       params: {
            //         email: user.email,
            //         name: user.name,
            //       },
            //     });
            //     setNotifMessage("Thank you! We will contact you shortly.");
            //     setSnackOpen(true); // ✅ SHOW SNACKBAR
            //     setTimeout(() => setSnackOpen(false), 3000);
            //     setTimeout(() => setContactButtonDisable(false), 3000);
            //   } catch (e) {
            //     console.error("Failed to send contact acknowledgement email", e);
            //   }
          }}
          disabled={contactButtonDisable}
          sx={{
            // mt: { xs: "1rem", sm: "1.25rem" },
            width: "fit-content",
            height: "2rem",
            padding: "0.5rem 1rem",
            borderRadius: "1.75rem",
            border: "1px solid #1F2D5C",
            //background: "#0036DD",
            color: "#1F2D5C",
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Akkurat",
            fontSize: "var(--Button-Primary-Size, 0.875rem)",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "var(--Button-Primary-Line-height, 1rem)", // 114.286%
            letterSpacing: "var(--Button-Primary-Spacing, 0.03125rem)",
            textTransform: "none",
          }}
        >
          Contact us
        </Button>
      </Box>
      <ContactUsPopup
        open={Opencontactus}
        onClose={() => setOpencontactus(false)}
        prefillData={{
          email: userData?.emailId,
          name: userData?.userName,
          phone: userData?.phoneNumber,
          userDomain: userData?.userDomain,
          userRole: userData?.userRole,
          remarks: userData?.remarks,
          jobTitle: userData?.jobTitle,
          organisation: userData?.organisation,
          emailContact:
            (userData?.contactPreference != null &&
              userData?.contactPreference.includes("Email")) ||
            false,
          phoneContact:
            (userData?.contactPreference != null &&
              userData?.contactPreference.includes("Phone")) ||
            false,
          isUserLoged: true,
        }}
      />
      <SuccessBanner open={snackOpen} message={notifMessage} />
    </Box>
  );
}